import React from 'react'
import {
  Container,
  TextTitle,
  HtmlContent,
  TextBody,
  Button,
  Icon
} from '@pmi/pmi-iqos-ds-react'
import { localstorage } from '@pmi/pmi-iqos-shared-react'

const QureHeader = ({
  translations,
  selfQureLogoBlock,
  deviceName,
  upgradeOffer = false,
  showBackBtn = true
}) => {
  return (
    <Container bg={upgradeOffer ? Container.backgrounds.white : null}>
      <Container bg={Container.backgrounds.primary}>
        <Container
          layout={Container.layouts.full}
          px={['8', '8', '16']}
          pt={['1', '2', '2']}
          pb={['2', '4', '4']}>
          <Container
            display={Container.displays.flex}
            alignItems={Container.alignItemsValues.center}>
            {selfQureLogoBlock && (
              <Container pt={['0', '0', '4']} pr="4">
                <HtmlContent content={selfQureLogoBlock} />
              </Container>
            )}
            <Container
              display={Container.displays.flex}
              flexDirection={[
                Container.flexDirections.column,
                Container.flexDirections.column,
                Container.flexDirections.row
              ]}
              justifyContent={Container.justifyContentValues.between}
              alignItems={[
                Container.alignItemsValues.start,
                Container.alignItemsValues.start,
                Container.alignItemsValues.center
              ]}>
              <TextTitle darkMode heading={TextTitle.headings.h5}>
                {translations.tk_deviceDiagnosticsPageTitle}
              </TextTitle>
              <TextBody
                darkMode
                size={TextBody.sizes.s}
                data-testing="QureHeader_TextBody_DeviceName">
                {deviceName}
              </TextBody>
            </Container>
          </Container>
        </Container>
      </Container>
      {showBackBtn ? (
        <Container
          layout={Container.layouts.full}
          px={['4', '4', '16']}
          pt={['4', '4', '6']}>
          <Button
            icon={Icon.images.arrowLeft}
            iconPosition={Button.iconPositions.left}
            onClickHandler={() => {
              upgradeOffer && localstorage.set('BackFromUpgradeOffer', true)
              window.history.back()
            }}
            text={translations.tk_upgradeOfferBackButton}
            variant={Button.variants.tertiary}
            data-testing="QureHeader_Button_Back"
          />
        </Container>
      ) : null}
    </Container>
  )
}

export default QureHeader
